__turbopack_context__.v({
  "border": "SettingListItem-module-scss-module__auYmaq__border",
  "center": "SettingListItem-module-scss-module__auYmaq__center",
  "left": "SettingListItem-module-scss-module__auYmaq__left",
  "list_in_right": "SettingListItem-module-scss-module__auYmaq__list_in_right",
  "right": "SettingListItem-module-scss-module__auYmaq__right",
  "right_icon": "SettingListItem-module-scss-module__auYmaq__right_icon",
  "state_item": "SettingListItem-module-scss-module__auYmaq__state_item",
  "sub_text": "SettingListItem-module-scss-module__auYmaq__sub_text",
  "title": "SettingListItem-module-scss-module__auYmaq__title",
  "title_text": "SettingListItem-module-scss-module__auYmaq__title_text",
  "wrap": "SettingListItem-module-scss-module__auYmaq__wrap",
});
